import merge from 'deepmerge'
import SuretyCrudRoutes from './SuretyCrudRoutes'

const routes = merge.all([SuretyCrudRoutes])


export default routes;

